export default class AxisLineUtil {
  static generateAxisLine(data) {
    return {
      show: true,
      lineStyle: {
        width: 20,
        color: [
          [0, '#C23531'],
          [0.5, '#C23531'],
          [0.5, 'orangered'],
          [0.7, 'orangered'],
          [0.7, 'orange'],
          [0.85, 'orange'],
          [0.85, 'green'],
          [1, 'green']
        ].map((item, index, array) => {
          if (item[0] > data) {
            item[1] = '#dce3ec';
          } else {
            if (array[index + 1] && array[index + 1][0] > data) {
              item[0] = data;
            }
          }
          return item;
        })
      }
    };
  }
}
